const visualElementStore = new WeakMap();

export { visualElementStore };
